export const ZOE = 'zsobin';
export const CHRIS = 'cfreeley';
export const WILL = 'wtruong';
export const DEFAULT_OWNER = WILL;